module.exports = __webpack_public_path__ + "static/media/omega-mobile-icon.0ed32a4c.png";